// @ts-nocheck
import React, { useMemo } from "react";
import { Chart as ChartJS, registerables } from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { Scatter, Line, Bar } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import zoomPlugin from "chartjs-plugin-zoom";
import { setAlertHighlightIndex } from "../../store/forecastSlice";

import { createTickCallback } from "../forecastGraphs/graphutil";
import { dateFormatZone } from "../forecastGraphs/forecastUtil";

ChartJS.register(...registerables, annotationPlugin, zoomPlugin);

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const percentileColors = [
  "#cfd5b3",
  "#abb57b",
  "#5e692e",
  "#abb57b",
  "#cfd5b3",
];

const areNumbersSwitched = (str1, str2) => {
  // Extract the first 5 characters and split by "-"
  const [num1a, num1b] = str1.substring(0, 5).split("-");
  const [num2a, num2b] = str2.substring(0, 5).split("-");

  // Check if the numbers are switched
  return num1a === num2b && num1b === num2a;
};

// Custom plugin to draw the vertical line CRAIG MOVE TO UTIL
const verticalLineIntersect = {
  id: "verticalLine",
  afterDraw: (chart) => {
    if (chart?.tooltip?._active && chart?.tooltip?._active?.length) {
      const ctx = chart.ctx;
      const activePoint = chart.tooltip._active[0];
      const x = activePoint.element.x;
      const topY = chart.scales.y.top;
      const bottomY = chart.scales.y.bottom;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, topY);
      ctx.lineTo(x, bottomY);
      ctx.lineWidth = 1;
      ctx.strokeStyle = "rgba(0, 0, 0, 0.8)";
      ctx.stroke();
      ctx.restore();
    }
  },
};

const ExploreGraph = React.memo(
  ({
    data,
    labels,
    // highResData,
    control,
    average,
    alerts,
    yaxis,
    timeZone,
    lineTension = 0.2,
  }) => {
    // console.log("dtata", data);

    // Craig Extract to a util
    const maxYValue = useMemo(
      () =>
        [...Object.values(data)]
          .flat()
          .reduce((max, item) => Math.max(max, item?.y), 0) * 1.1,
      [data]
    );

    const maxXValue = [...Object.values(data)]
      .flat()
      .reduce((max, item) => Math.max(max, new Date(item?.x).getTime()), 0);

    const minXValue = [...Object.values(data)]
      .flat()
      .reduce(
        (min, item) => Math.min(min, new Date(item?.x).getTime()),
        Infinity
      );

    const handleToggleVisibility = (e, legendItem) => {
      const index = legendItem.datasetIndex;
      const ci = e.chart;
      const meta = ci.getDatasetMeta(index);

      // Toggle the visibility
      meta.hidden = !meta.hidden;

      // Also toggle other datasets with the same group label
      ci.data.datasets.forEach((dataset, i) => {
        if (areNumbersSwitched(dataset.label, legendItem.text)) {
          ci.getDatasetMeta(i).hidden = meta.hidden;
        }
      });

      ci.update();
    };

    const options = useMemo(
      () => ({
        tension: lineTension,
        interaction: {
          mode: "nearest",
          intersect: false,
          axis: "x",
        },
        plugins: {
          zoom: {
            zoom: {
              wheel: {
                enabled: true, // Enable zooming with the mouse wheel
              },
              mode: "x", // Only allow zooming on the x-axis
            },
            limits: {
              x: {
                min: minXValue,
                max: maxXValue,
              },
            },
            pan: {
              enabled: true,
              mode: "x", // Only allow panning on the x-axis
            },
          },
          tooltip: {
            enabled: true,
            mode: "nearest", // Display the tooltip for all items in the index (stack)
            axis: "x",
            intersect: false, // Ensure the tooltip appears even if the mouse isn't directly over a dataset
            callbacks: {
              // Customize the tooltip
              beforeTitle: function (context) {
                // Optional: Add content before the title
              },
              title: function (context) {
                // Title content, if needed
                const newTimeDate = new Date(context[0].parsed.x);
                const { year, month, date, hour, minute, intTimeZone } =
                  dateFormatZone(newTimeDate, timeZone);
                return `${date}-${month}-${year} ${hour}:${minute} ${intTimeZone}`;
              },
              label: function (context) {
                // Customizing label to show desired data for each point in the stack
                const label = context.dataset.label || "";
                const value = context.parsed.y.toFixed(3);

                const regex = /^(\d+)-\d+ Percentile$/;
                const match = label.match(regex);

                // If a match is found, return the first captured group followed by " Percentile"
                if (match) {
                  return `${match[1]} Percentile: ${value}`;
                }

                return `${label}: ${value}`;
              },
              afterLabel: function (context) {
                // Optional: Add content after each label
              },
              footer: function (context) {
                // Optional: Add footer content
              },
            },
          },

          verticalLine: {},
          annotation: {
            annotations: {
              // Current time line removed
            },
          },
          legend: {
            onClick: handleToggleVisibility,
          },
        },
        maintainAspectRatio: false,
        spanGaps: true,
        scales: {
          x: {
            stacked: true,
            display: true,
            type: "time",

            title: {
              display: true,
              text: "",
            },
          },

          y: {
            display: true,
            title: {
              display: true,
              text: yaxis,
            },
            max: Math.ceil(maxYValue),
          },
        },
      }),
      [][(maxYValue, lineTension, timeZone)]
    );

    const boxplotData = useMemo(
      () => ({
        datasets: [
          ...data.map((record) => {
            return {
              label: record.label,
              type: "line",
              radius: 0,
              backgroundColor: record.backgroundColor,
              borderColor: record.borderColor,
              data: record.data,
            };
          }),
        ],
      }),
      [data]
    );

    if (!data) {
      return false;
    }

    if (data) {
      return (
        <div className="w-full h-full">
          <Line
            className="w-full h-full"
            options={options}
            data={boxplotData}
            plugins={[verticalLineIntersect]}
          />
        </div>
      );
    }
    return false;
  }
);

export default ExploreGraph;
